import { render, staticRenderFns } from "./Clerk.vue?vue&type=template&id=109b3e7b&scoped=true&"
import script from "./Clerk.ts?vue&type=script&lang=js&"
export * from "./Clerk.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109b3e7b",
  null
  
)

export default component.exports